module.exports = __webpack_public_path__ + "media/images/checkout/challenger/logo_clutter-bbcd24f036820efb5ae2c152641e9fef.svg";